import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MaintenancePayload {
  active: boolean;
  header?: string;
  body?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private key = 'app:maintenance';
  private _state = new BehaviorSubject<MaintenancePayload>({ active: false });
  state$ = this._state.asObservable();

  constructor(private http: HttpClient) {
    try {
      const raw = localStorage.getItem(this.key);
      if (raw) {
        this._state.next(JSON.parse(raw));
      }
    } catch {}
  }

  ping() {
    void this.init();
  }

  snapshot(): MaintenancePayload {
    return this._state.value;
  }

  async init(): Promise<void> {
    const url = `${environment.restURL.baseUrl}maintenance`;
    const res = await this.http
      .get<any>(url)
      .pipe(catchError(() => of(null)))
      .toPromise();

    const body = res?.data;
    const payload =
      res?.error === 0 &&
      typeof body?.backoffice === 'boolean' &&
      typeof body?.header === 'string' &&
      typeof body?.body === 'string';

    if (!payload) return;

    if (body.backoffice === true) {
      this.set({ active: true, header: body.header, body: body.body });
    } else {
      this.clear();
    }
  }

  set(payload: MaintenancePayload) {
    this._state.next(payload);
    try {
      localStorage.setItem(this.key, JSON.stringify(payload));
    } catch {}
  }

  clear() {
    this.set({ active: false });
  }
}
